import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const RemovePaymentMethodModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "RemovePaymentMethodModalContainer" */
      './RemovePaymentMethodModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
